<div class="stripe">
  <div>
    <ngx-stripe-card [options]="cardOptions" (change)="onChange($event)" [elementsOptions]="elementsOptions"
      (error)="error = $event"></ngx-stripe-card>
    <sl-label size="small" color="dark">{{error}}</sl-label>
  </div>
  <div class="text-right mt-6">
    <sl-button (click)="dialog.close()" i18n>Cancel</sl-button>
    <sl-button class="ml-3" (click)="getCardToken()" type="primary" [disabled]="!complete || loading" i18n>Save</sl-button>
  </div>
</div>